import { actionCreators as draftActionCreators } from 'app/area/case/draft/actions';
import { getEntityContext, contextToStorePath } from 'app/infrastructure/ui/renderer/resolvers';
import { columnName } from 'app/area/case/case-data-model';
import { getChildEntitiesFromPath } from 'app/area/case/features/resolvers';
import { entityRowsSelector } from 'app/area/case/features/file-upload/selectors';
import get from 'lodash/get';
import { getEntityTypeFromPath } from 'app/infrastructure/store/entity';

function selectFromState(state: any, uiEngineProps: any) {
  const hostProps = uiEngineProps.hostProps();
  const caseState = get(state, uiEngineProps.hostProps().statePath);
  const context = getEntityContext(caseState, uiEngineProps);

  return {
    state,
    hostProps,
    caseState,
    context
  };
}

// These can probably be replaced with the default ui-engine actionCreators
export const actionCreators = {
  addAttachment: (uiEngineProps, blobId, title) =>
    (dispatch: any, getState: any) => {
      const {
        context
      } = selectFromState(getState(), uiEngineProps);

      const entityType = getEntityTypeFromPath(uiEngineProps.componentDescriptor.entityTypePath);
      
      const initialValues = {};
      initialValues[(columnName[entityType] as { title: string }).title] = [{ value: title }];
      initialValues[(columnName[entityType] as { blob: string }).blob] = [{ value: blobId }];

      const parentPath = contextToStorePath(uiEngineProps.componentDescriptor, context);

      dispatch(draftActionCreators.addDocumentItem(parentPath, entityType, false, { initialValues }));
    },

  deleteAttachment: (uiEngineProps, id) =>
    (dispatch: any, getState: any) => {
      const {
        context
      } = selectFromState(getState(), uiEngineProps);

      const entityType = getEntityTypeFromPath(uiEngineProps.componentDescriptor.entityTypePath);

      const storePath =
        [
          ...contextToStorePath(uiEngineProps.componentDescriptor, context),
          {[entityType]: id}
        ];

      dispatch(draftActionCreators.deleteDocumentItem(true, storePath));
    },

  updateAttachmentTitle: (uiEngineProps, id, title) =>
    (dispatch: any, getState: any) => {
      const {
        context
      } = selectFromState(getState(), uiEngineProps);

      const entityType = getEntityTypeFromPath(uiEngineProps.componentDescriptor.entityTypePath);

      const storePath =
        [
          ...contextToStorePath(uiEngineProps.componentDescriptor, context),
          {[entityType]: id}
        ];

        dispatch(
          draftActionCreators.valueChanged(
            storePath,
            (columnName[entityType] as { title: string }).title,
            [{ value: title }]
        ));
      },
  setMainAttachmentImage: (uiEngineProps, id) =>
    (dispatch: any, getState: any) => {
      const state = getState();
      const { context } = selectFromState(state, uiEngineProps);

      const entityType = getEntityTypeFromPath(uiEngineProps.componentDescriptor.entityTypePath);

      const entities = getChildEntitiesFromPath(state, uiEngineProps, 0, entityType);

      const rows = entityRowsSelector(entities, entityType);

      const currentMainImages = rows.filter(item => item.mainImage);

      const updateImage = (imageId: number, value) => {
        const storePath = [
          ...contextToStorePath(uiEngineProps.componentDescriptor, context),
          {[entityType]: imageId}
        ];

        dispatch(
          draftActionCreators.valueChanged(
            storePath,
            (columnName[entityType]).mainImage,
            [{ value: value }]
        ));
      };

      currentMainImages.forEach(item => {
        updateImage(item.id, 0);
      });

      updateImage(id, 1);
    }
};
